import React, { Component } from 'react';
import Analytics from './Analytics';
import moment, { Moment } from 'moment';
import { connect } from 'react-redux';
import ResponseError from '../../models/ResponseError';
import { receiveError } from '../../store/actions/notificationAction';
import GhaModel from '../../models/Gha';
import User, { UserRoleId } from '../../models/User';
import userManagementRemote from '../../api/userManagementRemote';
import ApiResponse from '../../models/ApiResponse';
import AirlineType from '../../models/AirlineType';

interface AnalyticsContainerState {
  tab: string;
  airlines: AirlineType[];
  startDate: Moment;
  endDate: Moment;
};

interface AnalyticsContainerProps {
  match: { params: { tab: string } };
  receiveError: Function;
  gha: GhaModel;
  user: User;
};

class AnalyticsContainer extends Component<AnalyticsContainerProps, AnalyticsContainerState> {
  state = {
    tab: this.props.match.params.tab || 'customer-wait-time',
    airlines: [],
    startDate: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
    endDate: moment().set({ hour: 23, minute: 59, second: 59, millisecond: 0 }),
  }

  handleTab = (value: string): void => {
    this.setState({ tab: value });
  }

  handleChangeDate = (type: string, date: Moment): void => {
    const searchOptions = this.state;
    const days = searchOptions.endDate.diff(date, 'days');
    const date1 = date.clone();
    if (type === 'startDate' && days >= 7) {
      searchOptions.endDate = date.add('days', 7);
    }
    if (type === 'endDate' && days <= -7) {
      searchOptions.startDate = date1.add('days', -7);
    }
    if (type === 'startDate' && days < 0) {
      searchOptions.endDate = date;
    }
    switch (type) {
      case 'startDate':
        searchOptions.startDate = date1;
        break;
      case 'endDate':
        searchOptions.endDate = date;
        break;
      default: break;
    }
    this.setState({ ...searchOptions });
  }

  loadAirlines = (): void => {
    if (this.props.user.roleId == UserRoleId.GHA_SUPERVISOR || this.props.user.roleId == UserRoleId.GHA_MANAGER || this.props.user.roleId == UserRoleId.GHA_ADMIN) {
      userManagementRemote.getAirlines().then((resp: ApiResponse<Array<AirlineType>>) => {
        const airlines: Array<AirlineType> | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        if (airlines) {
          this.setState({
            airlines: airlines.filter((value, index, self) =>
              index === self.findIndex((t) => (
                t.iata_code === value.iata_code
              ))
            ) || []
          });
        }
        if (error) {
          this.props.receiveError(error);
        };
      });
    } else {
      userManagementRemote.getAirlinesForUser().then((resp: ApiResponse<Array<AirlineType>>) => {
        const airlines: Array<AirlineType> | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        if (airlines) {
          this.setState({
            airlines: airlines.filter((value, index, self) =>
              index === self.findIndex((t) => (
                t.iata_code === value.iata_code
              ))
            ) || []
          });
        }
        if (error) {
          this.props.receiveError(error);
        };
      });
    }
  }

  componentDidMount() {
    this.loadAirlines();
  }

  render() {

    return (
      <Analytics startDate={this.state.startDate} endDate={this.state.endDate} airlines={this.state.airlines} tab={this.state.tab} handleTab={this.handleTab} handleChangeDate={this.handleChangeDate} />
    );
  };
};


const mapStateToProps = (state: any) => {
  return {
    user: state.user,
    gha: state.ghaInfo
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsContainer);